import { UpdateWebhook } from "../schema/webhook";

/**
 * The body of an Edit Webhook save (PREC-4253). The form holds the URL the API sent, which is
 * masked where it carries a secret, so the URL goes out only when the user replaced it: a save
 * without `url` keeps the stored one, and the mask is never sent back as the receiver's address.
 */
export function buildWebhookUpdate(values: UpdateWebhook, isReplacingUrl: boolean): UpdateWebhook {
	const { url, ...rest } = values;

	return isReplacingUrl ? { ...rest, url } : rest;
}
